module.exports = __webpack_public_path__ + "img/milad-fakurian-PjG_SXDkpwQ-unsplash@2x.e42c40e5.png";